<template>
  <div no-body class="flex justify-end">
    <div class="">
      <b-pagination
        v-model="currentPage"
        pills:total-rows="rows"
        class="pagination-end"
        size="lg"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rows: 100,
      currentPage: 1,
    };
  },
};
</script>
